import {api} from '../../../shared/api';
import {AdminModel, AdminsFilter, AdminWithMetaModel, CreateAdminDTO, EditAdminDTO, EditAdminParams} from '../model';

export const adminsApi = {
  getAdmins: async (params: AdminsFilter = {}): Promise<AdminWithMetaModel> => {
    const {data} = await api.get<AdminWithMetaModel>('/api/iam/admin/administrators', {params});
    return data;
  },

  createAdmin: async (admin: CreateAdminDTO): Promise<AdminModel> => {
    const {data} = await api.post<AdminModel>('/api/iam/admin/administrators', admin);
    return data;
  },
  getAdminById: async (adminId: string): Promise<AdminModel> => {
    const {data} = await api.get<AdminModel>(`/api/iam/admin/administrators/${adminId}`);
    return data;
  },
  updateAdmin: async ({adminId, displayName}: EditAdminParams): Promise<AdminModel> => {
    const body: EditAdminDTO = {displayName};
    const {data} = await api.put<AdminModel>(`/api/iam/admin/administrators/${adminId}`, body);
    return data;
  },
};
